module.exports = __webpack_public_path__ + "media/COGEDIM_ITW_ARCHITECTES_VDEF.ade542de.mp4";